<ng-template #loadingTemplate>
    <div>Loading Contracts...<i class="fa fa-spinner fa-spin"></i></div>
</ng-template>
<div class="mt-2">
    <p-toolbar>
        <form [formGroup]="filterFormGroup" id="buildForm">
            <p-floatlabel class="w-full md:w-56" variant="on">
                <p-multiSelect
                    class="w-full"
                    inputId="csel"
                    maxSelectedLabels="1"
                    appendTo="body"
                    [options]="contracts"
                    [filter]="true"
                    formControlName="Contracts"
                    *ngIf="contracts; else loadingTemplate"
                >
                </p-multiSelect>
                <label for="csel">Select Contract(s)</label>
            </p-floatlabel>

            <!-- <span class="p-float-label">
                <p-multiSelect
                    defaultLabel="Filter"
                    maxSelectedLabels="1"
                    appendTo="body"
                    [options]="contracts"
                    [filter]="true"
                    formControlName="Contracts"
                    *ngIf="contracts; else loadingTemplate"
                >
                </p-multiSelect>
                <label for="float-dd" *ngIf="contracts">Select Contract(s)</label>
            </span> -->
            <p-toggleButton
                *ngIf="false"
                inputId="showhideDetails"
                onLabel="Hide Details"
                offLabel="Show Details"
                (onChange)="ToggleDetails.emit($event.checked)"
            ></p-toggleButton>
        </form>
        <p-message
            severity="info"
            text="Updates to Contract Burdens are effective for all periods processed/reprocessed after the changes are made.
            Reprocess previously processed periods as necessary.  Contract burdens do not apply to Contract Type of FFP."
        ></p-message>
    </p-toolbar>
</div>


